import { render, staticRenderFns } from "./InputText.vue?vue&type=template&id=6fad2d20&"
import script from "./InputText.ts?vue&type=script&lang=ts&"
export * from "./InputText.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports